import script from "./DigitalProductBuyButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductBuyButton.vue?vue&type=script&lang=js"
export * from "./DigitalProductBuyButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductBuyButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/digital-product-card/DigitalProductBuyButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d05e979c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d05e979c', __exports__)) {
    api.reload('d05e979c', __exports__)
  }
  
}


export default __exports__